import * as Conditions from './fields/conditions';
import * as DatePicker from './fields/datepicker';
import * as Locations from './fields/locations'
import * as MultiSelect from './fields/multiselect';
import * as PhoneNumberInput from './fields/phone_number_input'
import * as Widget from '../widgets/base';

export function init(config) {
  const widget = Widget.get(config);

  Conditions.init(widget);
  DatePicker.init(widget);
  Locations.init(widget);
  MultiSelect.init(widget);
  PhoneNumberInput.init(widget);
}
